(function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0], p = d.location.protocol;
    if (d.getElementById(id)) { return; }
    js = d.createElement(s);
    js.id = id; js.type = "text/javascript"; js.async = true;
    js.src = ((p == "https:") ? p : "http:") + "//plugin.mediavoice.com/plugin.js";
    fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "nativeads-plugin");

(function () {

    window.NATIVEADS = window.NATIVEADS || {};
    window.NATIVEADS_QUEUE = window.NATIVEADS_QUEUE || [];
    window.CSN = window.CSN || {};
    window.CSN.MediaMotive = window.CSN.MediaMotive || {};
    var sitePropertyId = $(".ncc-polar-section").data("property-id");

    var q = window.NATIVEADS_QUEUE;
    q.push(["setPropertyID", sitePropertyId]);
    q.push(["enableMOAT", true, true]);
    q.push(["injectCSS", "", "head"]);
    var viewId = Math.floor((Math.random() * 10000000000) + 1);
    var sasTags = function () {
        var retrieve = function (n) {
            var m, k = "kx" + n;
            if (window.localStorage) {
                return window.localStorage[k] || "";
            } else if (navigator.cookieEnabled) {
                m = document.cookie.match(k + "=([^;]*)");
                return (m && unescape(m[1])) || "";
            } else {
                return "";
            }
        }
        var user = retrieve("user");
        var segments = retrieve("segs");
        var ksg = "";
        if (segments) {
            ksg = segments;
        }
        return {
            kuid: user,
            ksg: ksg
        }
    }();

    var getTemplate = function () {
        var compiledTemplate0 = function(Handlebars, depth0, helpers, partials, data) {
            this.compilerInfo = [4, ">= 1.0.0"]; helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
            var buffer = "", stack1, stack2, options, functionType = "function", escapeExpression = this.escapeExpression, self = this, helperMissing = helpers.helperMissing;

            function program1(depth0, data) {
                 var buffer = "", stack1; buffer += "\n	     	<img src=\"" + escapeExpression(((stack1 = ((stack1 = depth0.custom), stack1 == null || stack1 === false ? stack1 : stack1.LogoLink)), typeof stack1 === functionType ? stack1.apply(depth0) : stack1)) + "\" width=\"50\" height=\"50\" class=\"sponsor-logo\">\n	   "; return buffer;
            }

            function program3(depth0, data) {
                 var buffer = "", stack1; buffer += "\n	     	<img src=\"" + escapeExpression(((stack1 = ((stack1 = ((stack1 = depth0.sponsor), stack1 == null || stack1 === false ? stack1 : stack1.logo)), stack1 == null || stack1 === false ? stack1 : stack1.href)), typeof stack1 === functionType ? stack1.apply(depth0) : stack1)) + "\" width=\"50\" height=\"50\" class=\"sponsor-logo\">\n	   "; return buffer;
            }

            buffer += "\n<li data-ad-type=\"" + escapeExpression(((stack1 = ((stack1 = depth0.custom), stack1 == null || stack1 === false ? stack1 : stack1.PlacementType)), typeof stack1 === functionType ? stack1.apply(depth0) : stack1)) + "\" data-advertiser-name=\"" + escapeExpression(((stack1 = ((stack1 = depth0.sponsor), stack1 == null || stack1 === false ? stack1 : stack1.name)), typeof stack1 === functionType ? stack1.apply(depth0) : stack1)) + "\">\n\n<div class=\"ncc-header\">\n\n	<div class=\"ncc-sponsor-logo\">\n\n	   ";
            stack2 = helpers["if"].call(depth0, ((stack1 = depth0.custom), stack1 == null || stack1 === false ? stack1 : stack1.LogoLink), { hash: {}, inverse: self.program(3, program3, data), fn: self.program(1, program1, data), data: data }); if (stack2 || stack2 === 0) { buffer += stack2; } buffer += "\n\n	</div>\n\n	<div class=\"ncc-title-container\">\n        <div class=\"ncc-title\">" + escapeExpression(((stack1 = ((stack1 = depth0.custom), stack1 == null || stack1 === false ? stack1 : stack1.HeaderURL)), typeof stack1 === functionType ? stack1.apply(depth0) : stack1)) + "</div>\n		\n		<div class=\"ncc-subtitle\"><a>" + escapeExpression(((stack1 = ((stack1 = depth0.custom), stack1 == null || stack1 === false ? stack1 : stack1.PlacementType)), typeof stack1 === functionType ? stack1.apply(depth0) : stack1)) + "</a></div>\n	</div>\n\n\n</div>\n\n<div class=\"ncc-main-text\">"; if (stack2 === helpers.title) { stack2 = stack2.call(depth0, { hash: {}, data: data }); } else { stack2 = depth0.title; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; } buffer += escapeExpression(stack2) + "</div>\n\n\n        \n           \n	    <a href=\""; if (stack2 === helpers.link) { stack2 = stack2.call(depth0, { hash: {}, data: data }); } else { stack2 = depth0.link; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; }

            buffer += escapeExpression(stack2) + "\" class=\"highlight-image\">\n			<img src=\"";
            options = { hash: { 'width': (250), 'height': (150) }, data: data }; buffer += escapeExpression(((stack1 = helpers.getThumbHref || depth0.getThumbHref), stack1 ? stack1.call(depth0, options) : helperMissing.call(depth0, "getThumbHref", options))) + "\" width=\"250\" height=\"150\">\n        </a>\n\n    <div class=\"description\">\n\n        <p>\n            ";

            if (stack2 === helpers.summary) {
                stack2 = stack2.call(depth0, { hash: {}, data: data });
            } else {
                 stack2 = depth0.summary; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
            }

            buffer += escapeExpression(stack2) + "\n        </p>\n    </div>\n	<span class=\"ncc-view-more\"> <a href=\"";

            if (stack2 === helpers.link) {
                stack2 = stack2.call(depth0, { hash: {}, data: data });
            } else {
                 stack2 = depth0.link; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2;
            }

            buffer += escapeExpression(stack2) + "\">View More ></a> </span>\n</li>";
            return buffer;
        };
        return compiledTemplate0;

    };
    var template = getTemplate();

    window.CSN.MediaMotive.registerPolarNative = function (option) {
        if (!option.custom) {
            option.custom = {};
        }
        option.custom.kuid = sasTags.kuid;
        option.custom.ksg = sasTags.ksg;
        option.custom.viewid = viewId;
        window.NATIVEADS_QUEUE.push([
            "insertPreview", {
                label: option.label || "",
                unit: {
                    "server": "sas",
                    "host": "mm.carsales.com.au",
                    "customer": "carsales",
                    "site": option.site,
                    "area": option.area,
                    "size": "2x2",
                    "custom": option.custom
                },
                location: option.location,
                template: template,
                onRender: function ($element) {
                    if (option.onRender) option.onRender($element);
                },
                onFill: option.onFill || function (data) {
                    //clearing sponsor link for display in card title, mediamotive requirement
                    data.custom.HeaderURL = data.custom.HeaderURL || data.sponsor.link.replace("http://", "");
                },
                onError: option.onError || function (error) {
                    window.CSN.MediaMotive.onNoFill(option.location);
                }
            }
        ]);
    };
})();